import React, { FC } from 'react';
import { Typography } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';

import { FlerboligbyggSummary } from '../../../../../services/types';
import { SmallTypography } from '../../../buildings/utils';
import { useDeleteFlerboligRegistration } from '../hooks/useDeleteFlerboligRegistration';
import {
  getFlerboligPathByEnergimerkeVersjon
} from '../../../../expertRegistration/common/utils';

import { RegistrationListItemWrapper } from './registrationListItemWrapper';


// This component shows information about an unpublished flerboligregistrering.
export const FlerboligRegistrationUnpublished: FC<{
  flerboligbygg: FlerboligbyggSummary;
}> = ({ flerboligbygg }) => {
  const { t } = useTranslation();

  const { isLoading, deleteFlerboligRegistration } = useDeleteFlerboligRegistration();

  const registrationPath = getFlerboligPathByEnergimerkeVersjon(flerboligbygg);

  const onDelete = () => {
    deleteFlerboligRegistration(flerboligbygg.flerboligbyggId);
  };

  return (
    <RegistrationListItemWrapper
      dateCreated={flerboligbygg.pabegyntDato}
      onDeleteRegistration={onDelete}
      registrationPath={registrationPath}
      isLoading={isLoading}
    >
      <SmallTypography variant="h4" component="p">
        {flerboligbygg.navn}
      </SmallTypography>
      <Typography>
        {t('expertRegistrationScreen.flerboligbygg.infoText', {
          count: flerboligbygg.antallRegistreringer
        })}
      </Typography>
    </RegistrationListItemWrapper>
  );
};
